"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSvgWrapper = exports.StyledSvg = exports.getApLogoStyles = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
exports.getApLogoStyles = function (theme) {
    var _a;
    var defaultLogoStyles = (_a = {},
        _a[types_1.LIGHT] = {
            fill: theme_1.colors.black
        },
        _a[types_1.DARK] = {
            fill: theme_1.colors.white
        },
        _a);
    return defaultLogoStyles[theme];
};
exports.StyledSvg = styled_components_1.default.svg({}, function (_a) {
    var theme = _a.theme, dimensions = _a.dimensions;
    return (__assign(__assign({}, exports.getApLogoStyles(theme)), { maxHeight: dimensions.height + "px" }));
});
exports.StyledSvgWrapper = styled_components_1.default.div({
    minWidth: '140px',
    width: '90%'
}, function (_a) {
    var _b;
    var dimensions = _a.dimensions;
    return (_b = {
            maxWidth: dimensions.width + "px"
        },
        _b[theme_1.mediaQuery(theme_1.breakpoints.md)] = {
            width: dimensions.width + "px"
        },
        _b);
});
//# sourceMappingURL=styles.js.map